import { Modal, message } from 'antd';
import * as React from 'react';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router';
import { createBooking, getBidRanksForBooking, getBookingChargeDetails } from 'src/api/booking';
import Navbar from 'src/components/navbar/Navbar';
import { InquiryModes } from 'src/Library/Constants';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import CreateEnquiry from '../CreateEnquiry';
import InformReason from './InformReason';
import UploadTruckingDOModal from './UploadTruckingDOModal';
import ViewBidRanking from './ViewBidRanking';
import ViewBreakdown from './ViewBreakdown';

const styles = (theme) => ({
  modalDiv: {
    width: '100% !important',
    top: 0,
    minWidth: '1080px',
    '& .ant-modal-header': {
      padding: '0 16px',
    },
  },
});
class CreateInquiryModal extends React.PureComponent<any, any> {
  state: any = {
    creatingBooking: false,
    cancelForm: false,
    protipVisible: false,
    inquiryData: undefined,
    viewBreakdownVisible: false,
    bookingApiData: {},
    chargeDetails: {},
    viewBidRanking: false,
    bidRankingData: {},
    viewInformReason: false,
    remark: '',
    topRankBid: undefined,
    selectedBid: undefined,
    confirmedBidId: undefined,
    isUploadDOModalVisible: false,
    accessType: null,
    teamIds: [],
  };

  closeViewBreakdown = () => {
    this.setState({
      viewBreakdownVisible: false,
    });
  };

  closeBidRanking = () => {
    this.setState({
      viewBidRanking: false,
    });
  };

  closeInformReason = () => {
    this.setState({
      viewInformReason: false,
    });
  };

  getBookingGACategory = () => {
    const { fromDiscoverRates } = this.props;
    return fromDiscoverRates
      ? EventCategories.DISCOVER_RATES_BOOKING_SHIPPER
      : EventCategories.INQUIRY_BOOKING_SHIPPER;
  };

  createBookingForShipper = async (bookingNote?) => {
    const { clickedFrom } = this.props;
    const { teamIds, accessType } = this.state;
    const createBookingData = {
      ...this.state.bookingApiData,
      ...bookingNote,
      bookingRemarks: this.state.remark ? this.state.remark : this.props.bookingReason,
      accessType,
      incoterm: this.props.incoterm,
      movementType: this.props.movementType,
      originServices: this.props.originServices,
      destinationServices: this.props.destinationServices,
      bidRankCriteria: 'RANK_WITHOUT_TAX'
    };
    if (accessType === 'TEAM'){
      if (teamIds!=null) createBookingData.teamIds = teamIds;
      else createBookingData.teamIds=[this.state.bookingApiData.bookingDetails.teamId];
    }
    const response = await createBooking(createBookingData);
    if (response.isSuccess) {
      sendEvent(this.getBookingGACategory(), 'Book Now - Successful', clickedFrom);
      this.setState({
        viewBreakdownVisible: false,
      });
      this.props.handleCancel(response.data.bookingNumber, response.data.bookingId);
    } else {
      sendEvent(this.getBookingGACategory(), 'Book Now - Failed', clickedFrom);
      message.error(response.errorMessage);
    }
  };

  setInquiryData = (data) => {
    this.setState({
      inquiryData: data,
    });
  };

  openInformReason = (selectedBid, topRankBid) => {
    this.setState({
      selectedBid,
      topRankBid,
      viewInformReason: true,
    });
  };

  getBidRankingData = async ({ teamIds, ...apiCallObject }) => {
    const { inquiryData } = this.state;
    const bidRankingApiData = {
      bookingDetails: {
        ...inquiryData,
        ...apiCallObject,
      },
      rankingCriteria: 'RANK_WITHOUT_TAX',
      bookingOrigin: 'INQUIRY',
    };
    const response = await getBidRanksForBooking(bidRankingApiData);
    if (response.isSuccess) {
      //Why this clickedFrom? Ans = https://shipsy.atlassian.net/browse/CORE-15083?focusedCommentId=192374
      
      if (this.props.clickedFrom === "Inquiry Card" || this.props.fromDiscoverRates){
        if (response.data?.data?.filter(bid => bid.isConfirmed === true).length > 1) {
          this.setState({
            accessType: apiCallObject.accessType,
            teamIds,
            bidRankingApiData,
            bidRankingData: response.data,
            viewBidRanking: true,
          });
        } else {
          this.setState({
            accessType: apiCallObject.accessType,
            teamIds,
            bidRankingApiData,
            bidRankingData: response.data,
          });
          if (this.props.clickedFrom === "Inquiry Card") {
            // Booking needs a reason when the only confirmed bid is not rank 1, same as the Bid List View flow
            const confirmedBid = response.data?.data?.find(bid => bid.isConfirmed === true);
            if (confirmedBid && String(confirmedBid.rank) !== String(1)) {
              this.openInformReason(
                confirmedBid,
                response.data?.data?.find(bid => String(bid.rank) === String(1)));
            } else {
              this.saveApiCallData(confirmedBid?.id);
            }
          } else {
            this.saveApiCallData(response.data?.data[0]?.id);
          }
      }
    }
      else if (this.props.clickedFrom === "Bid List View"){
        if (response.data?.data) {
          this.setState({
            accessType: apiCallObject.accessType,
            teamIds,
            bidRankingApiData,
            bidRankingData: response.data,
          });
          const {bidData} = this.props;
          if (
            String(bidData.rank) === String(1) 
          || bidData.reasonForNonL1BidConfirmation
          || String(bidData.id) === String(response.data.data.find(bid => String(bid.rank) === String(1))?.id) // sometimes(/getBidRanksForShipper) bidData.rank does not exist
          ){
            this.saveApiCallData(bidData.id);
          } else {
            this.openInformReason(
            bidData,
            response.data?.data?.find(bid => bid.rank === 1));
        }
      }
    }
    } else {
      message.error(response.errorMessage);
    }
  };

  setRemark = (val) => {
    this.setState({ remark: val });
  };

  saveApiCallData = async (bidId) => {
    const { inquiryData, bidRankingApiData } = this.state;

    const bookingApiData: any = {
      bidId,
      shipperId: bidRankingApiData.bookingDetails.shipperId,
      bookingDetails: {
        ...bidRankingApiData.bookingDetails,
        freightChargeId: this.props.freightChargeId,
      },
      bookingOrigin: 'INQUIRY',
      bookingRemarks: this.state.remark ? this.state.remark : undefined,
    };
    const response = await getBookingChargeDetails(bookingApiData);
    if (response.isSuccess) {
      bookingApiData.hash = response.data.hash;
      const bookingChargeObj = {
        bookingApiData,
        chargeDetails: {
          ...response.data.chargeDetails,
        },
        viewBreakdownVisible: true,
        creatingBooking: false,
      }
      if (!inquiryData?.exchangeRate?.referenceDate) {
        bookingChargeObj.chargeDetails.exchangeRate = inquiryData.exchangeRate;
      }
      this.setState({
        ...bookingChargeObj
      });
      sendEvent(this.getBookingGACategory(), 'Create Booking - Next');
    } else {
      message.error(response.errorMessage);
    }
  };

  getSelectedBidId = (confirmedBidId) => {
    this.setState({ confirmedBidId });
  };

  renderBookingModalTitle = (): React.ReactElement => {
    return (
      <Navbar
        pageTitle="Create Booking"
        styles={{
          border: 0,
          padding: 0,
        }}
      />
    );
  };

  render() {
    const { classes, fromDiscoverRates, freightChargeId } = this.props;
    const { inquiryData } = this.state;
    return (
      <Modal
        className={classes.modalDiv}
        visible={this.props.visible}
        closable={true}
        footer={false}
        onCancel={() => this.props.handleCancel()}
        title={this.renderBookingModalTitle()}
      >
        <CreateEnquiry
          visible={this.props.visible}
          handleCancel={() => this.props.handleCancel()}
          setInquiryData={this.setInquiryData}
          inquiryId={this.props.data.id}
          getBidRankingData={this.getBidRankingData}
          booking={true}
          getSelectedBidId={this.getSelectedBidId}
          fromDiscoverRates={fromDiscoverRates}
          freightChargeId={freightChargeId}
          bidData={this.props.bidData}
          bookingData={this.props.data}
        />
        {this.state.viewBidRanking && (
          <ViewBidRanking
            mode={inquiryData.mode}
            booking={true}
            bidRanking={this.state.bidRankingData}
            visible={this.state.viewBidRanking}
            handleCancel={this.closeBidRanking}
            createBooking={this.saveApiCallData}
            openInformReason={this.openInformReason}
            heading="Select Bid"
            confirmedBidId={this.state.confirmedBidId}
          />
        )}
        {this.state.viewInformReason &&
          !(
            this.state.selectedBid.id === this.state.inquiryData.confirmedBidId &&
            this.state.inquiryData.reasonForNonL1BidConfirmation
          ) && (
            <InformReason
              type={'SHIPPER'}
              booking={true}
              topRankBid={this.state.topRankBid}
              selectedBid={this.state.selectedBid}
              bidRanking={this.state.bidRankingData}
              chargeDetails={this.state.chargeDetails}
              visible={this.state.viewInformReason}
              handleCancel={this.closeInformReason}
              createBooking={this.saveApiCallData}
              setRemark={this.setRemark}
              heading="Reason"
              mode={inquiryData?.mode??'FCL'}
            />
          )}
        {this.state.viewBreakdownVisible && (
          <ViewBreakdown
            mode={inquiryData?.mode}
            type={'SHIPPER'}
            booking={true}
            bidId={this.state.chargeDetails.id}
            inquiryId={this.state.chargeDetails.objectId}
            chargeDetails={this.state.chargeDetails}
            visible={this.state.viewBreakdownVisible}
            handleCancel={this.closeViewBreakdown}
            createBooking={
              inquiryData.mode === InquiryModes.TRAILER
                ? () => this.setState({ isUploadDOModalVisible: true })
                : this.createBookingForShipper
            }
            isUpdatedCostStructure={true}
            inquiryData={inquiryData}
            freightChargeId={freightChargeId}
            heading="Updated Cost Structure"
          />
        )}
        {this.state.isUploadDOModalVisible && (
          <UploadTruckingDOModal
            isVisible={this.state.isUploadDOModalVisible}
            handleCancel={() => this.setState({ isUploadDOModalVisible: false })}
            handleSubmit={(bookingNote) => this.createBookingForShipper(bookingNote)}
            type={inquiryData?.type}
          />
        )}
      </Modal>
    );
  }
}
export default injectSheet(styles)(withRouter(CreateInquiryModal));
